import type { TranslationPluralKeyArg } from '../shared/types';

const SUPPORTED_SUFFIXES: readonly string[] = ['zero', 'one', 'two', 'few', 'many', 'other'];
const FALLBACK_SUFFIX = 'other';

// Locales where Intl.PluralRules returns "one" for 0 even though the
// language treats 0 as plural (e.g. pt-BR: "0 gatos" is plural).
// We deliberately diverge from CLDR here so existing `other:` strings
// render naturally for count=0 without per-call-site branching.
const ZERO_AS_OTHER_LOCALES: ReadonlySet<string> = new Set(['pt-BR']);

// Intl.PluralRules.select seems to sometimes return "other: n" in some environments
function normalizeSuffix(suffix: string) {
	return SUPPORTED_SUFFIXES.includes(suffix) ? suffix : FALLBACK_SUFFIX;
}

export function getPluralKey(locale: string, key: TranslationPluralKeyArg, count: number): string {
	if (count === 0 && ZERO_AS_OTHER_LOCALES.has(locale)) {
		return `${key as string}.other`;
	}
	const suffix = new Intl.PluralRules(locale).select(count);
	return `${key as string}.${normalizeSuffix(suffix)}`;
}
